import { calculator } from "./PriceCalculatorService";
class CouponCalculator {
  used_Coupons = [];
  calcAllCoupons(coupons, cartItems, rollintoSum = 0) {
    let totalDiscount = 0;
    this.used_Coupons = [];

    coupons.forEach((coupon) => {
      let couponResult = this.calculateCouponDiscountValue(
        coupon,
        cartItems,
        rollintoSum
      );
      totalDiscount += couponResult.totalDiscount;
      if (couponResult.isUsed) {
        this.used_Coupons.push(couponResult);
        coupon.isUsed = true;
      }
    });
    return totalDiscount;
  }
  calculateCouponDiscountValue(coupon, cartItems, rollintoSum = 0) {
    let totalDiscount = 0;
    let totalPercentDiscount = 0;
    let totalFreeDollarDiscount = 0;
    let isUsed = false;
    let appliedItems = [];
    let rollIntoSumApplied = false;
    if (!this.canCouponApply(coupon, cartItems, rollintoSum))
      return {
        coupon: coupon,
        totalDiscount: totalDiscount,
        percentDiscount: totalPercentDiscount,
        freeDollarDiscount: totalFreeDollarDiscount,
        isUsed: isUsed,
        appliedItems: appliedItems,
      };
    let candidates = this.getCouponCandidates(coupon, cartItems);

    let specific =
      coupon.Product ||
      (coupon.CouponCategory && coupon.CouponCategory.length > 0);
    let requiredQuantity = specific && coupon.MaximumQuantity;

    let maxAplicableQuantity = coupon.MaximumQuantity;
    candidates.forEach((candidate) => {
      let affectedQuantity = Math.min(
        candidate.quantity,
        requiredQuantity ? maxAplicableQuantity : Number.MAX_VALUE
      );
      let couponPercent;
      if (!rollIntoSumApplied) {
        couponPercent = this.calculatePercentDiscount(
          candidate,
          coupon,
          affectedQuantity,
          rollintoSum
        );
        rollIntoSumApplied = true;
      } else {
        couponPercent = this.calculatePercentDiscount(
          candidate,
          coupon,
          affectedQuantity,
          0
        );
      }
      totalPercentDiscount += couponPercent;

      let couponFreeDollar = 0;
      // apply free dollar discount once
      if (totalFreeDollarDiscount == 0 || specific) {
        couponFreeDollar = this.calculateFreeDollarDiscount(coupon);
        totalFreeDollarDiscount +=
          couponFreeDollar * (specific ? affectedQuantity : 1);
      }
      maxAplicableQuantity -= affectedQuantity;
      appliedItems.push({
        item: candidate,
        discount: couponPercent,
        freeDollarDiscount: couponFreeDollar,
        couponPercent: couponPercent,
      });
    });

    totalDiscount = totalFreeDollarDiscount + totalPercentDiscount;
    if (totalDiscount > 0) {
      isUsed = true;
    }
    return {
      coupon: coupon,
      totalDiscount: totalDiscount,
      percentDiscount: totalPercentDiscount,
      freeDollarDiscount: totalFreeDollarDiscount,
      isUsed: isUsed,
      appliedItems: appliedItems,
    };
  }
  getCouponCandidates(coupon, cartItems) {
    let candidates = cartItems.filter(
      (cartItem) =>
        (!coupon.Product &&
          (!coupon.CouponCategory || coupon.CouponCategory.length === 0)) ||
        cartItem.id + "" === coupon.Product ||
        coupon.CouponCategory.find(
          (itm) =>
            cartItem.ProductCategoryIDs &&
            cartItem.ProductCategoryIDs.indexOf &&
            cartItem.ProductCategoryIDs.indexOf(itm.ID + "") > -1
        )
    );
    let passCriteria = true;
    if (coupon.MinimumQuantity) {
      if (coupon.Product) {
        passCriteria = candidates[0].quantity >= coupon.MinimumQuantity;
      }
      if (coupon.CouponCategory && coupon.CouponCategory.length > 0) {
        let sum = 0;
        candidates.forEach((c) => {
          sum += c.quantity;
        });
        passCriteria = sum >= coupon.MinimumQuantity;
      }
    }
    return passCriteria ? candidates.sort((a, b) => a.price - b.price) : [];
  }
  canCouponApply(coupon, cartItems, rollintoSum) {
    if (!coupon || !cartItems) return false;
    if (cartItems.length == 0) return false;
    let couponMinimumSpent = coupon.MinSpent != null ? coupon.MinSpent : 0;
    let itemsValue = calculator.calcCartPrice(cartItems) + rollintoSum;
    if (couponMinimumSpent > 0 && itemsValue < couponMinimumSpent) return false;
    return true;
  }
  calculatePercentDiscount(
    candidate,
    coupon,
    affectedQuantity,
    rollintoSum = 0
  ) {
    if (coupon.PercentageValue && coupon.PercentageValue <= 0) return 0;
    const itemPricePlusRollinto =
      calculator.calcItemPrice(candidate, affectedQuantity) + rollintoSum;
    return itemPricePlusRollinto * (coupon.PercentageValue / 100);
  }
  calculateFreeDollarDiscount(coupon) {
    if (!coupon.FreeDollar || coupon.FreeDollar <= 0) return 0;
    return coupon.FreeDollar;
  }
}
export const couponCalculator = new CouponCalculator();
